import React from "react";

export default function RecordToggleButton({
  isRecording = false,
  onStart,
  onStop,
  disabled = false,
  title,
  className = "",
}) {
  return (
    <div className="relative group inline-flex items-center">
      <button
        type="button"
        className={`relative p-2 rounded-full transition-colors duration-200 
          disabled:opacity-50 disabled:cursor-not-allowed
          ${isRecording ? "text-red-600 hover:text-red-700" : "text-gray-600 hover:text-black"}
          ${className}`}
        title={title || (isRecording ? "Stop recording" : "Start recording")}
        aria-label={isRecording ? "Stop recording" : "Start recording"}
        onClick={isRecording ? onStop : onStart}
        disabled={disabled}
      >
        {/* Pulse animation when recording */}
        {isRecording && (
          <span
            className="absolute inset-0 rounded-full bg-red-500 opacity-25 animate-ping"
            aria-hidden="true"
          ></span>
        )}

        {/* Icon */}
        {isRecording ? (
          // Stop icon (square)
          <svg
            className="w-6 h-6 relative z-10"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <rect x="6" y="6" width="12" height="12" rx="2" />
          </svg>
        ) : (
          // Play icon (triangle)
          <svg
            className="w-6 h-6 relative z-10"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M8 5v14l11-7-11-7z" />
          </svg>
        )}
      </button>

      {/* Tooltip on hover */}
      <span
        className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 
        text-xs bg-gray-800 text-white rounded py-1 px-2 opacity-0 
        group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap"
      >
        {isRecording ? "Stop recording" : "Start recording"}
      </span>
    </div>
  );
}
